import React, { Component } from 'react';
import {Nav,Navbar} from 'react-bootstrap' 

class Naavbar extends Component {
    render() {
        return (
            <div>
                <Navbar bg='light' style={{width: "100vw"}} expand="lg">
                    <Navbar.Brand href="#" style={{fontWeight:900,color: "var(--mainBlue)"}}>George Githiri</Navbar.Brand>
                    <Navbar.Toggle aria-controls = "basic-navbar-nav"/>
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="ml-auto">
                            <Nav.Link href="#about" style={{color: '#3131a0',fontFamily:"'Courier New', Courier, monospace",fontSize:"16px"}}>About</Nav.Link>
                            <Nav.Link href="#skills" style={{color: '#3131a0',fontFamily:"'Courier New', Courier, monospace",fontSize:"16px"}}>Skills</Nav.Link>
                            <Nav.Link href="#projects" style={{color: '#3131a0',fontFamily:"'Courier New', Courier, monospace",fontSize:"16px"}}>Projects</Nav.Link>
                            <Nav.Link href="#contact" style={{color: '#3131a0',fontFamily:"'Courier New', Courier, monospace",fontSize:"16px"}}>Contact</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
            </div>
        );
    }
}



export default Naavbar;